import PropTypes from 'prop-types';
import React from 'react';
import { removeBookmark, bookmarkPage } from '../../../actions/bookmarks';
import classnames from 'classnames';
import connect from '../../connect';
import { isBookmarked } from '../../../selectors/bookmarks';

class BookmarkButton extends React.Component {
    static propTypes = {
        content: PropTypes.any,
        pagenum: PropTypes.number,
        bookmarked: PropTypes.bool.isRequired,
        removeBookmark: PropTypes.func.isRequired,
        bookmarkPage: PropTypes.func.isRequired,
    };

    handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        const { content, pagenum } = this.props;

        if (this.props.bookmarked) {
            this.props.removeBookmark(content, pagenum);
        } else {
            this.props.bookmarkPage(content, pagenum);
        }
    };

    handleKeyPress = e => {
        if (['Space', 'Enter'].indexOf(e.key) !== -1) {
            e.preventDefault();
            e.stopPropagation();
            return this.handleClick(e);
        }
    };

    render() {
        const { bookmarked } = this.props;
        const iconSuffix = bookmarked ? 'minus' : 'plus';
        const classes = classnames(
            'bookmark-button',
            'icon',
            'cl-icon',
            'cl-icon-bookmark-' + iconSuffix
        );
        return (
            <button
                className={classes}
                onClick={this.handleClick}
                onKeyDown={this.handleKeyPress}
                onKeyUp={this.handleKeyPress}
            >
                <span className="aural">bookmark pages</span>
            </button>
        );
    }
}

function mapStateToProps(state, props) {
    const bookmarked = isBookmarked(state, props.content, props.pagenum);

    return {
        bookmarked,
    };
}

export default connect(
    mapStateToProps,
    {
        removeBookmark,
        bookmarkPage,
    },
    null,
    { pure: true }
)(BookmarkButton);



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/bookmark_button.jsx